import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ja from './locales/ja.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      ja: {
        translation: ja,
      },
    },
    lng: 'ja', // Default language
    fallbackLng: 'ja',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
